import { setOneSignalTags } from '../config/onesignal'

const sendEvent = (eventName, properties = {}) => {
  // DevRev PLuG
  try {
    if (window.plugSDK && typeof window.plugSDK.trackEvent === 'function') {
      window.plugSDK.trackEvent(eventName, properties)
    }
  } catch (_) {}

  // OneSignal — track via tags (outcomes require dashboard config)
  try {
    const tagKey = properties.page_name
      ? `${eventName}_${properties.page_name}`.replace(/\s+/g, '_').toLowerCase()
      : properties.cta_name
        ? `${eventName}_${properties.cta_name}`.replace(/\s+/g, '_').toLowerCase()
        : properties.form_name
          ? `${eventName}_${properties.form_name}`.replace(/\s+/g, '_').toLowerCase()
          : properties.action
            ? `${eventName}_${properties.action}`.replace(/\s+/g, '_').toLowerCase()
            : eventName.replace(/\s+/g, '_').toLowerCase()
    setOneSignalTags({ [`last_${tagKey}`]: new Date().toISOString() })
  } catch (_) {}
}

// ---- Core helpers ----

export const trackEvent = (eventName, properties = {}) => {
  sendEvent(eventName, properties)
}

export const trackPageView = (pageName, properties = {}) => {
  sendEvent('page_view', { page_name: pageName, ...properties })
}

// ---- Page-level views ----

export const trackHomePageView = (properties = {}) => {
  sendEvent('page_view', { page_name: 'Home', ...properties })
}

export const trackDashboardView = (userId, metrics = {}) => {
  sendEvent('page_view', { page_name: 'Customer Dashboard', dashboard_user_id: userId, ...metrics })
}

export const trackPublicPoliciesView = (properties = {}) => {
  sendEvent('page_view', { page_name: 'Public Policies', ...properties })
}

export const trackContactPageView = (properties = {}) => {
  sendEvent('page_view', { page_name: 'Contact', ...properties })
}

export const trackAboutPageView = (properties = {}) => {
  sendEvent('page_view', { page_name: 'About', ...properties })
}

export const trackProfileView = (properties = {}) => {
  sendEvent('page_view', { page_name: 'Profile', ...properties })
}

export const trackPolicyDetailsView = (properties = {}) => {
  sendEvent('page_view', { page_name: 'Policy Details', ...properties })
}

export const trackClaimDetailsView = (properties = {}) => {
  sendEvent('page_view', { page_name: 'Claim Details', ...properties })
}

export const trackClaimView = (properties = {}) => {
  sendEvent('page_view', { page_name: 'Claims', ...properties })
}

export const trackHospitalView = (properties = {}) => {
  sendEvent('page_view', { page_name: 'Hospitals', ...properties })
}

// ---- CTA / interaction events ----

export const trackQuoteRequest = (properties = {}) => {
  sendEvent('cta_click', { cta_name: 'get_quote', ...properties })
}

export const trackContactFormSubmit = (properties = {}) => {
  sendEvent('form_submit', { form_name: 'contact', ...properties })
}

export const trackProfileUpdate = (properties = {}) => {
  sendEvent('form_submit', { form_name: 'profile_update', ...properties })
}

export const trackPolicyView = (properties = {}) => {
  sendEvent('cta_click', { cta_name: 'view_policy', ...properties })
}

export const trackNewPolicyClick = (properties = {}) => {
  sendEvent('cta_click', { cta_name: 'new_policy', ...properties })
}

export const trackPolicyDownload = (properties = {}) => {
  sendEvent('cta_click', { cta_name: 'download_policy', ...properties })
}

export const trackClaimSubmit = (properties = {}) => {
  sendEvent('form_submit', { form_name: 'claim_submit', ...properties })
}

export const trackHospitalSearch = (properties = {}) => {
  sendEvent('cta_click', { cta_name: 'hospital_search', ...properties })
}

// ---- Auth events ----

export const trackLoginPageView = (properties = {}) => {
  sendEvent('page_view', { page_name: 'Login', ...properties })
}

export const trackLoginAttempt = (properties = {}) => {
  sendEvent('auth', { action: 'login_attempt', ...properties })
}

export const trackLoginSuccess = (properties = {}) => {
  sendEvent('auth', { action: 'login_success', ...properties })
  setOneSignalTags({ last_login: new Date().toISOString(), user_type: properties.user_type || '' })
}

export const trackLoginFailure = (properties = {}) => {
  sendEvent('auth', { action: 'login_failure', ...properties })
}

export const trackRegisterPageView = (properties = {}) => {
  sendEvent('page_view', { page_name: 'Register', ...properties })
}

export const trackRegisterAttempt = (properties = {}) => {
  sendEvent('auth', { action: 'register_attempt', ...properties })
}

export const trackRegisterSuccess = (properties = {}) => {
  sendEvent('auth', { action: 'register_success', ...properties })
}

export const trackRegisterFailure = (properties = {}) => {
  sendEvent('auth', { action: 'register_failure', ...properties })
}

export const trackLogout = (properties = {}) => {
  sendEvent('auth', { action: 'logout', ...properties })
}

// ---- Navigation events ----

export const trackNavClick = (properties = {}) => {
  sendEvent('nav_click', properties)
}

export const trackSignOutClick = (properties = {}) => {
  sendEvent('cta_click', { cta_name: 'sign_out', ...properties })
}

// ---- Chat / widget events ----

export const openChatWithContext = (context, source) => {
  sendEvent('cta_click', { cta_name: 'open_chat', chat_source: source })

  if (!window.plugSDK?.toggleWidget) return

  const openChat = () => {
    try {
      if (context) {
        window.plugSDK.toggleWidget(true, 'create_conversation', {
          startConversationContent: context
        })
      } else {
        window.plugSDK.toggleWidget(true)
      }
    } catch (error) {
      try {
        window.plugSDK.toggleWidget(true)
      } catch (e) {}
    }
  }

  const attemptOpen = () => {
    if (window.plugSDK.isReady) {
      openChat()
    } else if (window.plugSDK.onReady) {
      window.plugSDK.onReady(openChat)
    } else {
      setTimeout(() => {
        openChat()
      }, 500)
    }
  }

  attemptOpen()
}
